// @flow
import React from 'react';
import {FormattedMessage} from 'react-intl';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import Typography from "@material-ui/core/Typography";
import CardContent from "@material-ui/core/CardContent";
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Chip from '@material-ui/core/Chip';

import type {User as UserType} from '../../../../types';
import Row from './Row';
import UserMenu from './UserMenu';

const useStyles = makeStyles(theme => ({
    card: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2)
    },
    cardHeader: {
        paddingBottom: 0
    },
    cardHeaderContent: {
        display: 'flex',
        justifyContent: 'space-between'
    },
    cardContent: {
        '&:last-child': {
            paddingBottom: 16
        }
    },
    chip: {
        backgroundColor: (props) => (props.active ? theme.palette.success.main : theme.palette.grey.A100),
        color: (props) => (props.active ? theme.palette.common.white : 'inherit')
    },
    listItem: {
        padding: 0
    },
}));

export type Props = $ReadOnly<{
    user: UserType,
    onEdit: (user: UserType) => void
}>;

function User({user, onEdit}: Props) {
    const active = true;
    const classes = useStyles({active});

    const handleEdit = () => {
        onEdit(user);
    };

    return (
        <Card raised={false}
              classes={{root: classes.card}}
        >
            <CardHeader
                classes={{root: classes.cardHeader, content: classes.cardHeaderContent }}
                title={<Typography variant="h6" component="span">{user.name}</Typography>}
                subheader={active &&
                <Chip className={classes.chip} size="small" label={<FormattedMessage
                    id="options.user.active"
                    defaultMessage="Active"
                />}/>
                }
                action={
                    <UserMenu
                        className={classes.menu}
                        user={user}
                        onEdit={handleEdit}
                    />
                }

            />
            <CardContent classes={{ root: classes.cardContent }}>
                <List dense={true} disablePadding={true}>
                    <ListItem classes={{ root: classes.listItem }}>
                        <ListItemIcon>
                            <FormattedMessage
                                id="options.user.email"
                                defaultMessage="Email"
                            />
                        </ListItemIcon>
                        <ListItemText
                            primary={user.email}
                        />
                    </ListItem>
                    {user.phone && <ListItem classes={{ root: classes.listItem }}>
                        <ListItemIcon>
                            <FormattedMessage
                                id="options.user.phone"
                                defaultMessage="Phone"
                            />
                        </ListItemIcon>
                        <ListItemText
                            primary={user.phone}
                        />
                    </ListItem>}
                </List>

                {/*<Typography variant="body2" color="textSecondary" component="p">*/}
                {/*<Row*/}
                {/*    label={(*/}
                {/*        <FormattedMessage*/}
                {/*            id="options.user.email"*/}
                {/*            defaultMessage="Email"*/}
                {/*        />*/}
                {/*    )}*/}
                {/*    value={user.email}*/}
                {/*/>*/}
                {/*<Row*/}
                {/*    label={(*/}
                {/*        <FormattedMessage*/}
                {/*            id="options.user.phone"*/}
                {/*            defaultMessage="Phone"*/}
                {/*        />*/}
                {/*    )}*/}
                {/*    value={user.phone}*/}
                {/*/>*/}
                {/*</Typography>*/}
            </CardContent>

            {/*<div className={classes.left}>*/}
            {/*    <div>*/}
            {/*        {user.name}*/}
            {/*    </div>*/}
            {/*    <Row*/}
            {/*        label={(*/}
            {/*            <FormattedMessage*/}
            {/*                id="options.user.email"*/}
            {/*                defaultMessage="Email"*/}
            {/*            />*/}
            {/*        )}*/}
            {/*        value={user.email}*/}
            {/*    />*/}
            {/*    <Row*/}
            {/*        label={(*/}
            {/*            <FormattedMessage*/}
            {/*                id="options.user.phone"*/}
            {/*                defaultMessage="Phone"*/}
            {/*            />*/}
            {/*        )}*/}
            {/*        value={user.phone}*/}
            {/*    />*/}
            {/*</div>*/}

            {/*<div className={classes.right}>*/}
            {/*    {active &&*/}
            {/*    <div className={classes.active}>*/}
            {/*        <FormattedMessage*/}
            {/*            id="options.user.active"*/}
            {/*            defaultMessage="Active"*/}
            {/*        />*/}
            {/*    </div>*/}
            {/*    }*/}

            {/*    <UserMenu*/}
            {/*        className={classes.menu}*/}
            {/*        user={user}*/}
            {/*        onEdit={handleEdit}*/}
            {/*    />*/}
            {/*</div>*/}
        </Card>
    );
}

export default User;